import Vue, { VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { CombinedVueInstance } from 'vue/types/vue';

function handleZerosBinding() {
	return (el: HTMLElement, binding: DirectiveBinding, vNode: VNode) => {
		el.addEventListener('input', (event) => {
			const target = event.target as HTMLTextAreaElement;
			const context: CombinedVueInstance<Vue, unknown, unknown, unknown, any> = vNode.context;
			const value = target.value.replace('00', '');

			if (target.value.startsWith('00')) {
				if (/\./.test(binding.expression))
					context[binding.expression.replace(/\..+/, '')][binding.expression.replace(/.+?\./, '')] = value;
				else
					context[binding.expression] = value;
			}
		});
	};
}

Vue.directive('handleZeros', {
	bind: handleZerosBinding()
});
